module.exports = __webpack_public_path__ + "static/catalog-footer-bcc326737d1bedda3d9463613be03693.png";